import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5v.5m0 3v1.5m0 3v6","key":"svg-0"}],["path",{"d":"M18 13l-6 6","key":"svg-1"}],["path",{"d":"M6 13l6 6","key":"svg-2"}]]

const IconArrowDownDashed = createReactComponent('outline', 'arrow-down-dashed', 'ArrowDownDashed', __iconNode);

export default IconArrowDownDashed;